import React from "react";
import { connect } from "react-redux";
import * as actions from "../../actions/actions";

class Seats extends React.Component {
    handleChange = seats => {
        let { minSeats, stripeNumSeatsChange } = this.props;
        stripeNumSeatsChange(seats, minSeats);
    };

    handleBlur = seats => {
        let { minSeats, stripeNumSeatsBlur } = this.props;
        stripeNumSeatsBlur(seats, minSeats);
    };

    render() {
        let { minSeats, seats, coupon } = this.props;
        return (
            <div className="seat-container clearfix">
                <li>
                    <div>
                        <label
                            htmlFor="seats"
                            className="seat-label enterprise"
                        >
                            How many members on your team? <br />
                            {coupon ? (
                                <span className="label-note">
                                    Enterprise teams must have {minSeats}+ seats
                                </span>
                            ) : null}
                        </label>
                        <input
                            id="seats"
                            type="number"
                            className="seats input"
                            name="seats"
                            placeholder={minSeats}
                            maxLength="3"
                            min={minSeats}
                            value={seats}
                            required
                            style={{ width: "100%" }}
                            onChange={e => this.handleChange(e.target.value)}
                            onBlur={e => this.handleBlur(e.target.value)}
                            disabled={this.props.processing}
                        />
                    </div>
                </li>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let { stripe } = state;
    let { seats, processing } = stripe;
    return {
        seats,
        processing
    };
};

export default connect(mapStateToProps, {
    stripeNumSeatsChange: actions.stripeNumSeatsChange,
    stripeNumSeatsBlur: actions.stripeNumSeatsBlur
})(Seats);
